class StyleGuideTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-style-guide-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-style-guide-panel]'));
    this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick.bind(this)));
  }

  onTabClick(event) {
    const selectedTab = event.currentTarget;
    const selectedPanelId = selectedTab.getAttribute('aria-controls');

    this.tabs.forEach((tab) => {
      const isActive = tab === selectedTab;
      tab.classList.toggle('is-active', isActive);
      tab.classList.toggle('button--primary', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.id === selectedPanelId;
      panel.classList.toggle('is-active', isActive);
      panel.toggleAttribute('hidden', !isActive);
    });
  }
}

if (!customElements.get('style-guide-tabs')) {
  customElements.define('style-guide-tabs', StyleGuideTabs);
}